/*
 * shipping-progress.js — Safer Lighting
 * <free-shipping-bar>: live progress to $500 free shipping (updates instantly
 *   from the theme's cart-update event — no reload) + FBT top-up nudge.
 * <gta-fulfillment>: same-day GTA delivery gate by postal FSA.
 */
(function () {
  function formatMoney(cents, format) {
    const fmt = format || '${{amount}}';
    function wd(n, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      const parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const tok = m ? m[1] : 'amount';
    let v;
    switch (tok) {
      case 'amount_no_decimals': v = wd(cents, 0); break;
      case 'amount_with_comma_separator': v = wd(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = wd(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': v = wd(cents, 2, ' ', ','); break;
      default: v = wd(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  if (!customElements.get('free-shipping-bar')) {
    customElements.define('free-shipping-bar', class extends HTMLElement {
      connectedCallback() {
        this.threshold = parseInt(this.dataset.threshold, 10) || 100000;
        this.fmt = this.dataset.moneyFormat || '${{amount}}';
        this.bar = this.querySelector('[data-ship-bar]');
        this.msg = this.querySelector('[data-ship-msg]');
        this.remainingEl = this.querySelector('[data-ship-remaining]');

        // nudge "+ Add" buttons
        this.querySelectorAll('[data-ship-add]').forEach((b) =>
          b.addEventListener('click', () => this.addNudge(b)));

        // instant update from the theme's cart-update pubsub
        if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          this.unsub = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (e) => {
            var cart = e && (e.cartData || (e.data && e.data.cartData));
            if (cart && typeof cart.items_subtotal_price === 'number') this.update(cart.items_subtotal_price);
          });
        }
        // animate fill on first paint
        if (this.bar) { var w = this.bar.style.width; this.bar.style.width = '0%'; requestAnimationFrame(() => { this.bar.style.width = w; }); }
      }
      disconnectedCallback() { if (this.unsub) this.unsub(); }

      update(subtotal) {
        var pct = this.threshold > 0 ? Math.min(100, Math.round((subtotal / this.threshold) * 100)) : 0;
        var remaining = Math.max(0, this.threshold - subtotal);
        if (this.bar) { this.bar.style.width = pct + '%'; this.bar.classList.toggle('is-full', subtotal >= this.threshold); }
        var track = this.querySelector('[role="progressbar"]'); if (track) track.setAttribute('aria-valuenow', pct);
        if (subtotal >= this.threshold) {
          if (this.msg) { this.msg.classList.add('sl-ship__msg--won'); this.msg.innerHTML = '<span class="sl-ship__spark" aria-hidden="true">★</span> You’ve unlocked <strong>FREE shipping</strong> on this order!'; }
        } else if (this.remainingEl) {
          this.remainingEl.textContent = formatMoney(remaining, this.fmt);
        } else if (this.msg) {
          this.msg.classList.remove('sl-ship__msg--won');
          this.msg.innerHTML = 'You’re <strong data-ship-remaining>' + formatMoney(remaining, this.fmt) + '</strong> away from <strong>FREE shipping</strong>';
          this.remainingEl = this.msg.querySelector('[data-ship-remaining]');
        }
      }

      async addNudge(btn) {
        btn.disabled = true;
        var id = Number(btn.dataset.variantId);
        var notif = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var sections = notif && notif.getSectionsToRender ? notif.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];
        try {
          var res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections, sections_url: window.location.pathname }),
          });
          var data = await res.json();
          if (notif && notif.renderContents) notif.renderContents(data);
          if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'free-shipping-bar', cartData: data });
          // if on the cart page (no notification re-render of the page), refresh it
          if (!notif && /\/cart(\/|$|\?)/.test(window.location.pathname)) window.location.reload();
        } catch (e) { btn.disabled = false; }
      }
    });
  }

  if (!customElements.get('gta-fulfillment')) {
    customElements.define('gta-fulfillment', class extends HTMLElement {
      connectedCallback() {
        this.prefixes = (this.dataset.fsa || '').split(',').map((s) => s.trim().toUpperCase()).filter(Boolean);
        this.cutoff = this.dataset.cutoff || '2:00 PM';
        var input = this.querySelector('[data-gta-postal]');
        var btn = this.querySelector('[data-gta-check]');
        this.result = this.querySelector('[data-gta-result]');
        var run = () => this.check(input ? input.value : '');
        if (btn) btn.addEventListener('click', run);
        if (input) input.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); run(); } });
      }
      check(raw) {
        var fsa = String(raw || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 3);
        if (fsa.length < 3) { this.set('Please enter a valid postal code (e.g. L6T 4L8).', ''); return; }
        var inGta = this.prefixes.some((p) => fsa.indexOf(p) === 0);
        if (inGta) this.set('✓ Same-day delivery available to ' + fsa + ' — order by ' + this.cutoff + ' today. Choose it at checkout.', 'ok');
        else this.set('Same-day delivery isn’t available for ' + fsa + ', but FREE GTA pickup and fast Canada-wide shipping are. Free Ontario shipping over $500.', 'no');
      }
      set(msg, state) { if (!this.result) return; this.result.textContent = msg; state ? this.result.setAttribute('data-state', state) : this.result.removeAttribute('data-state'); }
    });
  }
})();
